import React from 'react';
import { useHistory } from 'react-router';
import { ExclamationTriangleFill } from 'react-bootstrap-icons';

const InvalidInviteLinkAlert = () => {
  const history = useHistory();

  const goHome = () => {
    history.push('/');
  };

  return (
    <div className="d-flex flex-column vh-100 justify-content-center align-items-center bg-light">
      <ExclamationTriangleFill size={40} className="text-danger mb-3" />
      <p className="mb-1 text-center largeFont">
        This invitation link is no longer valid. It may have expired or already been used.
      </p>
      <p className="text-center largeFont">Please request a new one.</p>
    </div>
  );
};

export default InvalidInviteLinkAlert;
